export default __webpack_public_path__ + "static/media/user_icon.255df0c6.png";